import FileSaver from 'file-saver';
import JSZip from 'jszip';

// https://api.sfrep.com/rpti/intro.html
export async function downloadRpti({
  pdfs,
  images,
  xml,
  zipName,
}: {
  pdfs?: { blob: Blob; name: string }[];
  images?: { blob: Blob; name: string }[];
  xml: Blob;
  zipName: string;
}): Promise<void> {
  const zip = new JSZip();

  zip.folder('Rtf');
  zip.folder('Pdf');
  zip.folder('Images');

  pdfs?.map((pdf) => {
    zip.file(`Pdf/${pdf.name}`, pdf.blob);
  });

  images?.map((image) => {
    zip.file(`Images/${image.name}`, image.blob);
  });

  zip.file('Report.xml', xml);

  const zippedFile = await zip.generateAsync({ type: 'blob' });

  FileSaver.saveAs(zippedFile, `${zipName}.rpti`);
}
